import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'STAYVORA',
    description: 'STAYVORA is a closed booking platform for private villas and apartments in Djerba, Zarzis, Hammamet, Tunis and Sousse.',
    placeholder: 'Book • Stay • Discover',
    url: getOrigin()
}
